export const sharedES_MX = {
	fiscalReportDateFilterHint:
		"Este filtro utiliza la fecha de la transacción, no la fecha de emisión de la factura fiscal.",
	fiscalReportDateFilterRechargeHint:
		"Este filtro utiliza la fecha de la recarga, no la fecha de emisión de la factura fiscal.",
	yes: "Sí",
	no: "No",
};
